import { jsx as t } from "react/jsx-runtime";
const s = _ref => {
  let {
    iconStep: i,
    className: o
  } = _ref;
  return /* @__PURE__ */t("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "14",
    viewBox: "0 0 73 14",
    fill: "none",
    className: o,
    children: Array(4).fill(0).map((e, r) => {
      const c = r * 20 + 6;
      return r < i ? /* @__PURE__ */t("circle", {
        cx: c,
        cy: "7",
        r: "6",
        fill: "#303030"
      }, r) : /* @__PURE__ */t("circle", {
        cx: c,
        cy: "7",
        r: "6",
        stroke: "#303030"
      }, r);
    })
  });
};
export { s as ExcursionActivityLevelIcon };